/**
 * Pure helpers for External Evaluation recreation-interval CMS settings
 * (AssessmentDetails save / dirty detection).
 */

export const RECREATION_INTERVAL_VALIDATION_MESSAGE =
  'Recreation interval days must be 0 (admin re-grant only) or at least 1 when immediate restore is off';

/**
 * @param {boolean} localImmediate
 * @param {number|string|null|undefined} localDays
 * @param {boolean} schemaImmediate
 * @param {number|null|undefined} schemaDays
 * @returns {boolean}
 */
export function hasRecreationIntervalSettingsChanged(
  localImmediate,
  localDays,
  schemaImmediate,
  schemaDays,
) {
  const immediateChanged = localImmediate !== schemaImmediate;

  if (localImmediate) {
    return immediateChanged;
  }

  const isEmpty = localDays === null || localDays === undefined || localDays === '';
  if (isEmpty) {
    return immediateChanged;
  }

  const schemaValue = schemaDays ?? 0;
  return immediateChanged || localDays !== schemaValue;
}

/**
 * @param {boolean} immediate
 * @param {number|string|null|undefined} days
 * @returns {{ ok: true } | { ok: false, message: string }}
 */
export function validateRecreationIntervalForSave(immediate, days) {
  if (immediate === true) {
    return { ok: true };
  }

  const isEmpty = days === null || days === undefined || days === '';
  if (isEmpty || !Number.isFinite(Number(days)) || Number(days) < 0) {
    return { ok: false, message: RECREATION_INTERVAL_VALIDATION_MESSAGE };
  }

  return { ok: true };
}

/**
 * @param {boolean} immediate
 * @param {number|string|null|undefined} days
 * @returns {{ recreationImmediateAfterCycle: boolean, recreationIntervalDays?: number|string }}
 */
export function buildRecreationIntervalSavePayload(immediate, days) {
  if (immediate === true) {
    return { recreationImmediateAfterCycle: true };
  }
  return {
    recreationImmediateAfterCycle: false,
    recreationIntervalDays: days,
  };
}
